import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ServiceInitAddContainer from 'src/ui/features/ServiceInit/containers/ServiceInitAddContainer';
import ServiceInitLandingContainer from 'src/ui/features/ServiceInit/containers/ServiceInitLandingContainer';
import ServiceInitBatchContainer from 'src/ui/features/ServiceInit/containers/ServiceInitBatchContainer';
import { updateBodyClass } from 'src/helpers';
import { setSITab } from './state/serviceInitActions';
import Layout from 'src/ui/layout';
import {
  SERVICEINIT_URL,
  SERVICEINIT_URL_ADDSI,
  BODY_CLASSES,
  SERVICEINIT_DETAILS_URL,
  SERVICEINIT_URL_BATCHSI,
  // DASHBOARD_URL,
} from 'src/constants/constants.js';
import { connect } from 'react-redux';
import { SERVICEINIT_PAGE_URL } from '../../../constants/constants';
import intl from 'react-intl-universal';
import { getUserInfoSelector } from 'src/ui/features/Login/state/loginReselect';
import { newDashboardRoutes } from 'src/newDashboardRoutes';
import { getDashboardURL } from 'src/helpers/commonFunctions';

class ServiceInitRoot extends React.Component {
  componentDidMount() {
    // Check if contact has service initiation rights, redirect to dashboard if not
    const { userInfo } = this.props;
    if (!userInfo || !userInfo.serviceInitiationRights) {
      window.location.href = getDashboardURL();
    }

    updateBodyClass(BODY_CLASSES.SERVICEINIT);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.SERVICEINIT);
  }

  render() {
    return (
      <Layout headerName={intl.get('serviceInit.landing.topBar.serviceInitiation')}>
        <Switch>
          <Route path={SERVICEINIT_PAGE_URL} exact={true} render={props => <ServiceInitAddContainer {...props} />} />
          <Route path={SERVICEINIT_DETAILS_URL} render={props => <ServiceInitAddContainer {...props} />} />
          <Route path={SERVICEINIT_URL_ADDSI} render={props => <ServiceInitAddContainer {...props} />} />
          <Route path={SERVICEINIT_URL_BATCHSI} render={props => <ServiceInitBatchContainer {...props} />} />
          <Route path={SERVICEINIT_URL} render={props => <ServiceInitLandingContainer {...props} />} />
        </Switch>
        {newDashboardRoutes}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    location: state.router.location.pathname,
    login: state.login,
    userInfo: getUserInfoSelector(state),
  };
};

const mapDispatchToProps = {
  setSITab: setSITab,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceInitRoot);
